module.exports = __webpack_public_path__ + "img/ic_show_sidebar.7850eff4.svg";